import { renderTopLevelComponent } from 'app/scripts/controller/renderTopLevelComponent';
import { LazyAppManagement } from 'app/src/components/AppManagement';
import { controllerEvents } from './controllerEvents';

export const powerupEditPowerUpPage = () => {
  controllerEvents.trigger('setViewType', 'power-ups-edit');
  renderTopLevelComponent(<LazyAppManagement />);
};
